import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ModalContext from './context';

class ModalProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.array,
      PropTypes.object
    ]).isRequired
  };

  state = {
    showModal: {},
    onClose: props => this.onModalClose(props),
    onOpen: props => this.onModalOpen(props)
  };

  onModalOpen(name) {
    this.addSrollLock();
    this.setState({
      showModal: {
        [name]: true
      }
    });
  }

  onModalClose(name) {
    this.removeSrollLock();
    this.setState({
      showModal: {
        [name]: false
      }
    });
  }

  addSrollLock = () =>
    document.querySelector('html').classList.add('u-lock-scroll');

  removeSrollLock = () =>
    document.querySelector('html').classList.remove('u-lock-scroll');

  render() {
    const { children } = this.props;

    return (
      <ModalContext.Provider
        value={{
          modal: {
            ...this.state
          }
        }}
      >
        {children}
      </ModalContext.Provider>
    );
  }
}

export default ModalProvider;
